
export class AppleSignInDataRequestDto {
  authorizationCode: string;
  firstName: string;
  lastName: string;
}
